import { AuthProvider } from 'pages/AuthContext'; // Import your AuthProvider
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/color.css';
import './styles/font.css';
import './styles/index.css';
import './styles/tailwind.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppProvider } from 'Contexts/AppContext';
import { NotificationProvider } from 'Contexts/NotificationContext';

// Configuration FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUpload,
  faFilePdf,
  faEye,
  faEdit,
  faTrash,
  faDownload,
  faPrint,
  faSearch,
  faPlus,
  faMinus,
  faCheck,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';

// Ajouter les icônes à la bibliothèque
library.add(
  faUpload,
  faFilePdf,
  faEye,
  faEdit,
  faTrash,
  faDownload,
  faPrint,
  faSearch,
  faPlus,
  faMinus,
  faCheck,
  faTimes,
  faExclamationTriangle,
  faInfoCircle
);

// Ne pas afficher l'erreur ResizeObserver "undelivered notifications" (bénin, ex. modals rsuite)
const resizeObserverErr = /ResizeObserver|undelivered notifications/;
const isResizeObserverLog = (a) => {
  if (typeof a === 'string') return resizeObserverErr.test(a);
  if (a && typeof a === 'object' && a.message) return resizeObserverErr.test(String(a.message));
  return false;
};
const _consoleError = console.error;
console.error = (...args) => {
  if (args.some(isResizeObserverLog)) return;
  _consoleError.apply(console, args);
};
window.addEventListener('error', (e) => {
  if (resizeObserverErr.test(e.message || '')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    const overlay = document.getElementById(
      'webpack-dev-server-client-overlay'
    );
    if (overlay) overlay.remove();
    return true;
  }
}, true);
const _onerror = window.onerror;
window.onerror = (msg, ...rest) => {
  if (typeof msg === 'string' && resizeObserverErr.test(msg)) return true;
  return _onerror ? _onerror(msg, ...rest) : false;
};

const queryClient = new QueryClient();
ReactDOM.render(
  // <Provider store={store}>
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <AppProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </AppProvider>
    </AuthProvider>
  </QueryClientProvider>,
  // </Provider>,
  document.getElementById('root')
);
